import script from "./HomeArticleSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeArticleSlider.vue?vue&type=script&setup=true&lang=js"

import "./HomeArticleSlider.vue?vue&type=style&index=0&id=1053b654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1053b654"]])

export default __exports__